import JsonMapperModuleResolver from "./JsonMapperModuleResolver";
import { getBlockInstance } from "@/assets/js/mcn-helpers";
export default class BlockJsonMapperModuleResolver extends JsonMapperModuleResolver {
  static getResolvedModule(data) {
    return getBlockInstance(data === null || data === void 0 ? void 0 : data.type, 'model', false);
  }
}